/** Stable section ids from impact DB question migration (see frontend/constants/impactSectionIds.ts). */
export const IMPACT_SECTION_IDS = {
  carry: 920040,
  emissionSources: 920041,
  customDefine: 920042,
  customClassify: 920043,
  customMeasure: 920044,
  customSubmit: 920045,
  customSolutions: 920046,
  customSolutionEditor: 920047,
  impactProfile: 920048,
  introNotes: 920049,
  ghgResult: 920050,
  growthFactor: 920051,
  fairComparison: 920052,
  strategyImpactStrategy: 1944,
  strategyTheoryOfChange: 1945,
} as const

export type ImpactSectionId =
  (typeof IMPACT_SECTION_IDS)[keyof typeof IMPACT_SECTION_IDS]
